
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/ipillion",
      function () {
        return require("private-next-pages/projects/ipillion.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/ipillion"])
      });
    }
  